import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getLanderPage } from '~/utils/sanity';
import { generateMetaHead } from '~/utils/head';
import Modules from '~/components/sanity/modules/Modules.vue';
import SanityLanderHeader from '~/components/sanity/SanityLanderHeader.vue';
import SanityLanderFooter from '~/components/sanity/SanityLanderFooter.vue';
import { getFeatureValue } from '~/utils/isomorphicGrowthbook';
const RANDOM_STRING = uuidv4();
export default {
  components: {
    Modules,
    SanityLanderHeader,
    SanityLanderFooter
  },
  layout: 'empty',
  async asyncData({
    req,
    route,
    store,
    error,
    $cookies,
    redirect
  }) {
    let slug = route.path;
    if (slug.includes('affirm')) {
      $cookies.set('extra_ef_affid', 331);
      $cookies.set('extra_ef_oid', 10);
    }
    if (route.fullPath === '/affirm') {
      redirect('/affirm?affid=331&oid=10');
      return;
    }
    const abTest = store.state.sanityData.abTests.find(ab => `/${ab.slug}` === slug);
    let anonymousId;
    if ($cookies.get('ajs_anonymous_id')) {
      anonymousId = $cookies.get('ajs_anonymous_id');
    } else {
      anonymousId = RANDOM_STRING;
      $cookies.set('ajs_anonymous_id', RANDOM_STRING, {
        path: '/'
      });
    }
    if (abTest) {
      const {
        featureFlag
      } = abTest;
      const variation = await getFeatureValue(featureFlag, {
        attributes: {
          anonymousId
        },
        defaultValue: 'control'
      });
      slug = abTest.variations.find(({
        variantName
      }) => variation.toLowerCase() === variantName.toLowerCase()).slug;

      // redirect to homepage when variant is homepage
      if (slug === '/') {
        redirect(`/?referrer=${route.params.sanity}`);
      }
    }
    return await getLanderPage(slug).then(async data => {
      if (_.isEmpty(data)) error({
        statusCode: 404
      });
      if (process.server) {
        const {
          analyticsHub
        } = await import('~/server/analyticsHub');
        analyticsHub.page({
          anonymousId,
          category: 'Website Visited',
          name: 'server lander',
          context: {
            userAgent: req.get('User-Agent')
          },
          properties: {
            referrer: route.path,
            url: route.fullPath,
            search: `?${new URLSearchParams(route.query).toString()}`
          }
        });
      }
      return {
        ...data,
        isAbTest: !!abTest
      };
    }).catch(() => error({
      statusCode: 404
    }));
  },
  head() {
    return generateMetaHead({
      ...this.seo
    });
  },
  computed: {
    footerStyle() {
      if (!this.layout.footer.styles) return;
      const {
        color,
        backgroundColor
      } = this.layout.footer.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundColor && {
          backgroundColor
        }),
        'border-top': '1px solid #E6E6E6'
      };
      return style;
    }
  }
};